import { renderIsomorphicComponent, renderComponent, renderBreakingNews } from "@quintype/framework/client/start";
import get from "lodash/get";

import { pickComponent } from "../isomorphic/pick-component";
import LoadingIndicatorComponent from "../isomorphic/components/atoms/loading-indicator";
import BreakingNewsSliderView from "../isomorphic/components/BreakingNewsSlider";

import TopAd from "../isomorphic/components/molecules/TopAd";
import { pickFooter } from "../isomorphic/pick-footer";
import NewHeader from "../isomorphic/components/layouts/header/NewHeader";
import InterstitialAd from "../isomorphic/components/molecules/InterstitialAd";
import AdAsia from "../isomorphic/components/molecules/AdAsia";

export function preRenderApplication(store) {
  const hydrate = { hydrate: !global.qtLoadedFromShell };
  renderComponent(NewHeader, "header", store, hydrate);
  renderComponent(LoadingIndicatorComponent, "loading-indicator", store);
}

// This is a separate file as everything from here on is hot reloaded when the app changes
export function renderApplication(store) {
  const domainSlug = get(store.getState(), ["qt", "config", "domainSlug"], null);
  const pageType = get(store.getState(), ["qt", "pageType"], null);
  const hydrate = { hydrate: !global.qtLoadedFromShell };
  pageType !== "story-page" && renderComponent(TopAd, "top-ad", store, hydrate);
  renderComponent(InterstitialAd, "interstitial-ad", store, hydrate);
  renderComponent(AdAsia, "ad-asia", store, hydrate);
  pickFooter().then((footer) => renderComponent(footer.default, "footer", store));
  if (!domainSlug) {
    renderBreakingNews("breaking-news-container", store, BreakingNewsSliderView, hydrate);
  }
  renderIsomorphicComponent("container", store, pickComponent, {
    hydrate: !global.qtLoadedFromShell,
  });
}
